import { render } from "./Movments.vue?vue&type=template&id=4e4b1248"
import script from "./Movments.vue?vue&type=script&lang=js"
export * from "./Movments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__